import { useState, useEffect } from 'react'

const LS_THEME = "estoqueos_theme";
const LS_A11Y  = "estoqueos_a11y";

function loadPrefs(){
  try{
    const t=localStorage.getItem(LS_THEME);
    const a=localStorage.getItem(LS_A11Y);
    return{
      dark: t===null ? true : t==="dark",
      a11y: a==="1",
    };
  }catch(e){ return{dark:true,a11y:false}; }
}

const A11Y_STYLE_ID="estoqueos-a11y-style";

function applyClasses(dark,a11y){
  const classes=[dark?"dark":"light"];
  if(a11y)classes.push("a11y");
  document.body.className=classes.join(" ");
  let el=document.getElementById(A11Y_STYLE_ID);
  if(a11y){
    if(!el){el=document.createElement("style");el.id=A11Y_STYLE_ID;document.head.appendChild(el);}
    el.textContent=`
      body.a11y p, body.a11y span, body.a11y td, body.a11y th, body.a11y li { font-weight:700!important; line-height:1.65!important; letter-spacing:0.01em!important; }
      body.a11y button, body.a11y input, body.a11y select, body.a11y textarea { font-weight:700!important; font-size:13px!important; }
      body.a11y div { font-weight:700!important; }
    `;
  }else{
    if(el)el.remove();
  }
}

const prefs=loadPrefs();
let _dark=prefs.dark;
let _a11y=prefs.a11y;
applyClasses(_dark,_a11y);

let _themeListeners=[];
let _a11yListeners=[];

function setGlobalDark(val){
  _dark=val;
  try{ localStorage.setItem(LS_THEME,val?"dark":"light"); }catch(e){}
  applyClasses(_dark,_a11y);
  _themeListeners.forEach(fn=>fn(val));
}

function setGlobalA11y(val){
  _a11y=val;
  try{ localStorage.setItem(LS_A11Y,val?"1":"0"); }catch(e){}
  applyClasses(_dark,_a11y);
  _a11yListeners.forEach(fn=>fn(val));
}

function useTheme(){
  const [dark,setDark]=useState(()=>_dark);
  useEffect(()=>{
    _themeListeners.push(setDark);
    return()=>{ _themeListeners=_themeListeners.filter(f=>f!==setDark); };
  },[]);
  return[dark,()=>setGlobalDark(!_dark)];
}

function useA11y(){
  const [a11y,setA11y]=useState(()=>_a11y);
  useEffect(()=>{
    _a11yListeners.push(setA11y);
    return()=>{ _a11yListeners=_a11yListeners.filter(f=>f!==setA11y); };
  },[]);
  return[a11y,()=>setGlobalA11y(!_a11y)];
}

function useIsMobile(){
  const [mobile,setMobile]=useState(()=>window.innerWidth<700);
  useEffect(()=>{
    const fn=()=>setMobile(window.innerWidth<700);
    window.addEventListener("resize",fn);
    return()=>window.removeEventListener("resize",fn);
  },[]);
  return mobile;
}

function useIsNarrow(threshold=768){
  const [narrow,setNarrow]=useState(()=>document.documentElement.clientWidth<threshold);
  useEffect(()=>{
    const el=document.documentElement;
    const obs=new ResizeObserver(entries=>{
      for(const e of entries)setNarrow(e.contentRect.width<threshold);
    });
    obs.observe(el);
    return()=>obs.disconnect();
  },[threshold]);
  return narrow;
}

export { useTheme, useA11y, useIsMobile, useIsNarrow }